module.exports = __webpack_public_path__ + "static/media/pt-PT.1afddef5.md";